import { Injectable } from '@angular/core';
import { SESSIONS_RC } from '@core/constants/routes.constants';
import { Role } from '@core/constants';

const DEFAULT_ROUTE_MAP: { [key in Role]: string } = {
  [Role.ADMIN]: SESSIONS_RC.root,
  [Role.SUPER_ADMIN]: SESSIONS_RC.root,
  [Role.COORDINATOR]: SESSIONS_RC.root,
  [Role.PARENT]: SESSIONS_RC.root,
  [Role.DIRECTOR_MANAGER]: SESSIONS_RC.root,
  [Role.GENERAL_MANAGER]: SESSIONS_RC.root,
};

@Injectable({ providedIn: 'root' })
export class DefaultRouteApi {
  resolveDefaultRoute(role: Role): string {
    return DEFAULT_ROUTE_MAP[role];
  }
}
